import React from "react";
import { Link } from "react-router-dom";

function TeamSection({ data, team }) {
  const pageData = data || {};
  const teamData = team || [];

  const defaultTeam = [
    {
      id: 1,
      name: "Rebecca Edwards",
      position: "Ավագ խորհրդատու",
      image: "assets/img/bg-img/10.jpg",
    },
    {
      id: 2,
      name: "Shawn S. Kerendian",
      position: "Փոխտնօրեն",
      image: "assets/img/bg-img/11.jpg",
    },
    {
      id: 3,
      name: "Rebecca Edwards",
      position: "Ավագ խորհրդատու",
      image: "assets/img/bg-img/12.jpg",
    },
  ];

  const teamMembers = teamData.length > 0 ? teamData : defaultTeam;

  return (
    <section className="lawyers-team-section bg-white">
      <div className="divider"></div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-7 col-xl-6">
            <div className="section-heading text-center">
              <div className="sub-title justify-content-center">
                <img src="assets/img/core-img/hammer.png" alt="" />
                Մեր Պրոֆեսիոնալ Աշխատակազմը
              </div>
              <h2>
                {pageData.team_title ||
                  "Մեր բացառիկ մասնագիտական թիմը՝ ձեր հաջողության համար"}
              </h2>
            </div>
          </div>
        </div>

        <div className="row justify-content-center g-4">
          {teamMembers.map((member) => (
            <div key={member.id} className="col-12 col-sm-6 col-md-4">
              <div className="laywer-card">
                <img
                  src={member.image}
                  alt={member.name}
                  onError={(e) => {
                    e.target.src = "assets/img/bg-img/10.jpg";
                  }}
                />

                <div className="laywer-info text-center">
                  <div className="laywer-name">{member.name}</div>
                  <div className="laywer-position">{member.position}</div>
                </div>

                <div className="hover-laywer-info text-center">
                  <div className="laywer-name">{member.name}</div>
                  <div className="laywer-position">{member.position}</div>

                  <div className="social-nav">
                    {member.facebook && (
                      <Link to={member.facebook}>
                        <i className="ti ti-brand-facebook"></i>
                      </Link>
                    )}
                    {member.twitter && (
                      <Link to={member.twitter}>
                        <i className="ti ti-brand-x"></i>
                      </Link>
                    )}
                    {member.linkedin && (
                      <Link to={member.linkedin}>
                        <i className="ti ti-brand-linkedin"></i>
                      </Link>
                    )}
                    {member.instagram && (
                      <Link to={member.instagram}>
                        <i className="ti ti-brand-instagram"></i>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="divider"></div>
    </section>
  );
}

export default TeamSection;
